import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { DaoGeneric } from '@Services/base/daoService';
import { RoleEntite } from '../index';
import { environment } from '@Env/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageRoleService extends DaoGeneric<RoleEntite> {
  private url = `${environment.baseUrl}/api_bdc/manageroles/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  deleteRole(role_entite) {
    const url = `${this.url}?role_entite=${role_entite}`;

    return this.httpClient.delete(url);
  }

  createRoleBase(role, individu) {
    const url = `${this.url}`;
    const data = {individu: individu, role: role};

    return this.httpClient.post(url, JSON.stringify(data));
  }
}
